import React, { CSSProperties, Fragment, ReactNode } from 'react';
import { uniqueId } from 'lodash';

export const getHighlightedText = (
  text: string,
  highlight: string,
  highlightStyle: CSSProperties,
): ReactNode => {
  const parts = text.split(new RegExp(`(${highlight})`, 'gi'));

  return (
    <>
      {parts.map((part) => {
        if (part.toLowerCase() === highlight.toLowerCase())
          return (
            <span key={uniqueId()} style={highlightStyle}>
              {part}
            </span>
          );

        return <Fragment key={uniqueId()}>{part}</Fragment>;
      })}
    </>
  );
};
